import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
} from "@mui/material";
import {
    CloseRounded,
    CropRounded,
} from "@mui/icons-material";
import { CircleStencil, FixedCropper } from 'react-advanced-cropper';
import 'react-advanced-cropper/dist/style.css';

const _CorporateLogoCropModal = ({
    open,
    onClose,
    imageToCrop,
    cropperRef,
    ratio,
    onConfirmUpload,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: 4, p: 1 } }}
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
                <Stack direction="row" spacing={1.5} alignItems="center">
                    <CropRounded color="primary" />
                    <Typography variant="h6" sx={{ fontWeight: 800 }}>برش و تنظیم لوگوی سازمان</Typography>
                </Stack>
                <IconButton onClick={onClose} size="small">
                    <CloseRounded />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
                <FixedCropper
                    ref={cropperRef}
                    src={imageToCrop}
                    stencilComponent={CircleStencil}
                    stencilProps={{
                        aspectRatio: 1,
                        handlers: false,
                        lines: false,
                        movable: false,
                        resizable: false,
                    }}
                    stencilSize={{
                        width: ratio ? ratio.MAXW : 600,
                        height: ratio ? ratio.MAXH : 600,
                    }}
                    className={'cropper'}
                />
            </DialogContent>
            <DialogActions sx={{ px: 2, pb: 2, gap: 1 }}>
                <Button variant="outlined" onClick={onClose} sx={{ borderRadius: 2 }}>
                    انصراف
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onConfirmUpload}
                    sx={{ borderRadius: 2, fontWeight: 700, px: 3 }}
                >
                    ذخیره لوگو
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default _CorporateLogoCropModal;
